import axios from "axios";
import { BASE_URL } from "../utils/EmpUtil";

export default class DealerNotesClient {
  static baseUrl = BASE_URL;

  static saveDealerNotes(dealerId, requestBody) {
    const url = `${this.baseUrl}/dealer/dealernotes/${dealerId}/save-dealer-notes`;
    return axios.post(url, requestBody);
  }

  static updateDealerNotes(requestBody) {
    const url = `${this.baseUrl}/dealer/dealernotes/update-dealer-notes`;
    return axios.put(url, requestBody);
  }

  static getDealerNotes(orderId, pageNumber = 0, pageSize = 3) {
    const queryParams = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    const url = `${this.baseUrl}/dealer/dealernotes/${orderId}/get-dealer-notes?${queryParams}`;
    return axios.get(url);
  }

  static deleteDealerNotes(id) {
    const url = `${this.baseUrl}/dealer/dealernotes/delete-dealer-notes/${id}`;
    return axios.delete(url);
  }
}
